module.exports = __webpack_public_path__ + "static/media/cgnLogo.2f304326.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cgnLogo.png
// module id = 1428
// module chunks = 0